// Volatile tracking only. A missing response is not permission to repeat a POST.
export const bulkDeliveryState = () => ({ sending: false, job: null, error: null, hold: false, subjectType: null, context: {} });
export const createBulkDelivery = ({ state, request, completed = () => {}, schedule = setTimeout, cancel = clearTimeout }) => {
  let timer, generation = 0, polling = false, disposed = false;
  const stop = () => { cancel(timer); timer = null; };
  const apply = (job) => {
    if (!job || typeof job.job_id !== "string" || !["queued", "running", "completed"].includes(job.status)
      || !Array.isArray(job.rows) || !Number.isInteger(job.total) || !Number.isInteger(job.processed)) throw new Error("Invalid job status");
    state.job = job; state.error = job.status === "completed" && job.rows.some(row => row.outcome === "uncertain") ? "uncertain" : null;
    state.hold = job.status !== "completed" || job.rows.some(row => row.outcome === "uncertain");
    if (job.status === "completed") completed();
    else timer = schedule(poll, 2000);
  };
  const poll = async () => {
    if (disposed || polling || !state.job || state.job.status === "completed") return;
    stop(); polling = true; const version = generation, id = state.job.job_id;
    try {
      const { data } = await request.get(`/ncrm/privacy/invitations/bulk/jobs/${encodeURIComponent(id)}`, { timeout: 15000 });
      if (!disposed && version === generation) apply(data);
    } catch (error) {
      if (!disposed && version === generation) {
        state.hold = true;
        const status = error.response?.status;
        state.error = [401, 403].includes(status) ? "access" : status === 404 ? "unavailable" : "statusError";
        if (state.error !== "statusError") state.job = null;
      }
    } finally { polling = false; }
  };
  return {
    async start(params) {
      if (disposed || state.sending || state.hold || state.job) return false;
      state.sending = true; state.hold = true; state.error = null;
      state.subjectType = params.subject_type; const version = ++generation;
      state.context = { purpose_id: params.purpose_id, locale: params.locale, doi_after_accept: params.doi_after_accept };
      const input = { ...params, subject_ids: [...params.subject_ids] };
      try {
        const { data } = await request.post("/ncrm/privacy/invitations/bulk/send", input, { timeout: 45000 });
        if (disposed || version !== generation) return false;
        apply(data); return true;
      } catch (error) {
        if (!disposed && version === generation) {
          const status = error.response?.status;
          const rejected = status >= 400 && status < 500 && status !== 408;
          state.hold = !rejected;
          state.error = !rejected ? "uncertain" : [401, 403].includes(status) ? "access"
            : status === 409 ? "busy" : status === 429 ? "capacity" : "rejected";
        }
        return false;
      } finally { if (!disposed && version === generation) state.sending = false; }
    },
    retryStatus: poll,
    dismiss() { if (state.job?.status === "completed") state.job = null; },
    dispose() { disposed = true; generation++; stop(); state.job = null; },
  };
};
